import React from 'react';
import { NavLink } from 'react-router-dom';
import './ProjectCard.scss'
const ProjectCard = ({ project }) => {
    
    return (
      <div
        data-aos="flip-down"
        className="border-[0.3px] border-[#bfbecb20] rounded shadow-lg font-bold  max-w-[360px] bg-[#162033] h-[380px] p-[20px] lg:mb-0 lg:mx-0 "
      >
        {/* Cover Photo */}
        <div
          className="relative min-w-[319px] h-[250px] bg-cover bg-no-repeat bg-left-top cursor-pointer overlay-container hover:overlay"
          style={{
            backgroundImage: `url(${project?.cover})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundBlendMode: "overlay",
          }}
        >
          <div className="absolute overlay flex justify-center items-center">
            <NavLink to={`/project/${project?._id}`}>
              <button
                className="p-2  bg-black rounded-md text-gray-300 font-extrabold text-3xl"
                style={{ fontFamily: ' "Tangerine", cursive ' }}
              >
                See Details
              </button>
            </NavLink>
          </div>
        </div>
        <div className="">
          <h1 className=" text-white font-semibold my-3">{project?.name}</h1>
          <p className=" text-[#bfbecbc9] font-thin ">
            {project?.description.slice(0, 60)}...
          </p>
        </div>
      </div>
    );
};

export default ProjectCard;